
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum QuestionCategoryType {
	Product = 0,
	Company = 1,
	Order = 2
}
export namespace QuestionCategoryType {
	export function getKeys(): Map<QuestionCategoryType, string> {
		return new Map([[0, 'Product'], [1, 'Company'], [2, 'Order']]);
	}
}
